import type { DeleteCheckResponse } from "@repo/shared/types";
import { get } from "@/lib/api/_client";

const BASE = "/internal/client-cost-categories";

/** QL-168 — asked when Delete is clicked, before the confirmation opens. */
export function checkDelete(id: string): Promise<DeleteCheckResponse> {
  return get<DeleteCheckResponse>(`${BASE}/${id}/delete-check`);
}
